export enum TransactionItemStatusEnum {
  CANCELADO = "C",
  ATIVO = "A",
  PENDENTE = "P",
  DESFEITO = "D",
  QUESTIONADA = "Q", // contestada
  LIQUIDADO = "L",
  ESTORNADO = "E"
}

export enum GroupedTransactionStatusEnum {
  CONCLUIDO = "concluido",
  PENDENTE = "pendente",
  CANCELADO = "cancelado"
}
export const groupedTransactionStatus = {
  [GroupedTransactionStatusEnum.CONCLUIDO]: [
    TransactionItemStatusEnum.ATIVO,
    TransactionItemStatusEnum.LIQUIDADO
  ],
  [GroupedTransactionStatusEnum.PENDENTE]: [
    TransactionItemStatusEnum.PENDENTE,
    TransactionItemStatusEnum.QUESTIONADA
  ],
  [GroupedTransactionStatusEnum.CANCELADO]: [
    TransactionItemStatusEnum.CANCELADO,
    TransactionItemStatusEnum.DESFEITO,
    TransactionItemStatusEnum.ESTORNADO
  ]
};

export enum TransactionItemTypeLetterEnum {
  SAQUE = "S",
  COMPRA = "C",
  PONTUACAO = "P"
}

export enum TransactionItemTypeEnum {
  SAQUE = "SAQUE",
  COMPRA = "COMPRA",
  PONTUACAO = "PONTUACAO",
  PAGAMENTO = "PAGAMENTO"
}
export enum TransactionPaymentMethodEnum {
  CREDIT = "C"
}

export const transactionTypeLetter: {
  [key: string]: TransactionItemTypeLetterEnum;
} = {
  [TransactionItemTypeEnum.SAQUE]: TransactionItemTypeLetterEnum.SAQUE,
  [TransactionItemTypeEnum.COMPRA]: TransactionItemTypeLetterEnum.COMPRA,
  [TransactionItemTypeEnum.PONTUACAO]: TransactionItemTypeLetterEnum.PONTUACAO
};

export enum TypeOfInstallmentEnum {
  CASH_PURCHASE = 1,
  INSTALLMENT_BY_STORE = 2,
  INSTALLMENT_BY_CARD = 3
}

export const typeOfInstallment: { [key: number]: string } = {
  [TypeOfInstallmentEnum.CASH_PURCHASE]: "Compra à Vista (Crédito)",
  [TypeOfInstallmentEnum.INSTALLMENT_BY_STORE]: "Compra Parc. (Loja)",
  [TypeOfInstallmentEnum.INSTALLMENT_BY_CARD]: "Compra Parc. (Crédito)"
};
